import { AxiosError } from 'axios';
import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { PhysicianRequest, PhysicianUniquenessError } from '../../../Data/Physician';
import { dictionary } from '../../../dictionary';
import { NotificationType } from '../../../redux/initialState';
import { addNotification } from '../../../redux/notifications/notificationsActionCreator';
import { physicianService } from '../../../Services/PhysicianService';
import { FormFlow, FormFlowStepComponent } from '../../../Shared/FormFlow/FormFlow';
import { routes } from '../../../Utils/routes';
import { PhysicianForm } from '../shared/PhysicianForm';

const PhysicianFormWrapper: FC<FormFlowStepComponent<PhysicianRequest>> = ({ FormActionsComponent, onFormStepComplete }) =>
  <PhysicianForm FormActionsComponent={FormActionsComponent} onFormStepComplete={onFormStepComplete} />;

export const CreatePhysician: FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const onCancel = () => history.push(routes.physicians.index);
  const onComplete = async (request: PhysicianRequest) => {
    try {
      await physicianService.create(request);
      dispatch(addNotification(NotificationType.success, dictionary.CREATE_PHYSICIAN_SUCCESS));
      history.push(routes.physicians.index);
    } catch (exception) {
      // eslint-disable-next-line prefer-destructuring
      const response = (exception as AxiosError).response;
      if (response?.status === 409 && response?.data.message.includes(request.lastName)) {
        const uniquePhysicianError = response?.data.message;
        dispatch(addNotification(NotificationType.error, uniquePhysicianError));
      } else if (response?.status === 409) {
        const uniqueErr: PhysicianUniquenessError = response?.data;
        dispatch(addNotification(NotificationType.error, dictionary.PHYSICIAN_NOT_UNIQUE_ERROR(uniqueErr?.hospitalNames || [])));
      } else {
        dispatch(addNotification(NotificationType.error, dictionary.CREATE_PHYSICIAN_ERROR));
      }
    }
  };

  return (
    <FormFlow<PhysicianRequest>
      onComplete={onComplete}
      onCancel={onCancel}
      completeButtonLabel={dictionary.CREATE_PHYSICIAN_SUBMIT_BTN}
      steps={[
        { pageHeader: dictionary.CREATE_PHYSICIAN_PAGE_HEADER, component: PhysicianFormWrapper },
      ]}
    />
  );
};
